import PlusCircleSvg from "../../../../../../media/images/icons/plus-circle";
import { Box, Typography, useTheme } from "@mui/material";
import { addCommas } from "@persian-tools/persian-tools";
import { blueGrey } from "@mui/material/colors";
import { IPriceItem } from "..";

interface Props {
  priceItem?: IPriceItem;
  handleSelectPrice: (id?: number) => void;
}

export default function PriceItem(props: Props) {
  const { priceItem, handleSelectPrice } = props;
  const theme = useTheme();

  return (
    <Box
      onClick={() => handleSelectPrice(priceItem?.id)}
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: priceItem?.checked ? "primary.main" : blueGrey[400],
        gap: "4px",
        backgroundColor: theme.palette.bgColor.blueGrey50,
        padding: "6px 4px",
        borderRadius: "5px",
      }}
    >
      <PlusCircleSvg
        size={18}
        color={
          priceItem?.checked
            ? theme.palette.primary.main
            : theme.palette.textColor.main
        }
      />
      <Typography
        sx={{
          color: priceItem?.checked ? "primary.main" : "textColor.main",
        }}
      >
        {" "}
        {addCommas(priceItem?.value!)}
      </Typography>
      <Typography
        sx={{
          fontSize: "14px",
          color: priceItem?.checked ? "primary.main" : "textColor.main",
        }}
      >
        تومان
      </Typography>
    </Box>
  );
}
